import { component } from "picoapp";

export const linkList = component((node) => {
  const button = node.querySelector("[data-button]");
  const panel = node.querySelector("[data-panel]");
  const breakpoint = node
    .querySelector("[data-breakpoint]")
    .getAttribute("data-breakpoint");
  const defaultAccordionState = node
    .querySelector("[data-accordion-default-state]")
    .getAttribute("data-accordion-default-state");
  let accordionOpen = false;

  if (defaultAccordionState && defaultAccordionState === "open") {
    accordionOpen = true;
  }
  updateAccordionState();

  button.addEventListener("click", (event) => {
    event.preventDefault();
    if (window.innerWidth <= breakpoint) {
      toggle();
    }
  });

  function toggle() {
    accordionOpen = !accordionOpen;
    updateAccordionState();
  }

  function updateAccordionState() {
    if (accordionOpen) {
      openAccordion();
    } else {
      closeAccordion();
    }
  }

  function openAccordion() {
    button.ariaExpanded = "true";
    panel.classList.add("sm:block");
    panel.classList.remove("hidden");

    button.querySelector(".accordion-plus").classList.add("hidden");
    button.querySelector(".accordion-minus").classList.remove("hidden");
  }

  function closeAccordion() {
    button.ariaExpanded = "false";

    panel.classList.add("hidden");
    panel.classList.remove("sm:block");

    button.querySelector(".accordion-plus").classList.remove("hidden");
    button.querySelector(".accordion-minus").classList.add("hidden");
  }
});
